import { render, staticRenderFns } from "./employeesPage.vue?vue&type=template&id=696bff99&"
import script from "./employeesPage.vue.ts?vue&type=script&lang=ts&"
export * from "./employeesPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports